let COOKIE_EXPIRES: string = '';
let COOKIE_BEARER_TOKEN: string = '';
let COOKIE_USER_NAME: string = '';
let COOKIE_USER_SUBNAME: string = '';
let COOKIE_USER_EMAIL: string = '';
let COOKIE_USER_UUID: string = '';

import { environment } from '../../../environments/environment';

const prefix = environment.cookiePrefix || '';
const cookieName = (key: string) => (key.startsWith(prefix) ? key : `${prefix}${key}`);
const legacyPrefixes = ['pkg_administrator_'];

const cookieOpts = () => {
  const expires = new Date(Date.now() + 86400000).toUTCString();
  const isSecure = typeof location !== 'undefined' && location.protocol === 'https:';
  return `path=/;expires=${expires};SameSite=Lax${isSecure ? ';Secure' : ''}`;
};

export const createUserCookies = (token: string, user_name: string, sub_name: string, uuid: string, user_email: string) => {
  COOKIE_BEARER_TOKEN = token;
  COOKIE_USER_NAME = user_name;
  COOKIE_USER_SUBNAME = sub_name;
  COOKIE_USER_EMAIL = user_email;
  COOKIE_USER_UUID = uuid;
  COOKIE_EXPIRES = new Date(Date.now() + 86400000).toUTCString();
  const opts = cookieOpts();

  document.cookie = cookieName('bearer_token') + '=' + encodeURIComponent(COOKIE_BEARER_TOKEN) + ';' + opts;
  document.cookie = cookieName('user_name') + '=' + encodeURIComponent(COOKIE_USER_NAME) + ';' + opts;
  document.cookie = cookieName('user_subname') + '=' + encodeURIComponent(COOKIE_USER_SUBNAME) + ';' + opts;
  document.cookie = cookieName('user_uuid') + '=' + encodeURIComponent(COOKIE_USER_UUID) + ';' + opts;
  document.cookie = cookieName('user_email') + '=' + encodeURIComponent(COOKIE_USER_EMAIL) + ';' + opts;
};

/** Profil modifié (« Mon profil ») : le nom et le sous-titre affichés suivent sans se reconnecter. */
export const updateUserNameCookies = (user_name: string, sub_name: string) => {
  const opts = cookieOpts();
  document.cookie = cookieName('user_name') + '=' + encodeURIComponent(user_name) + ';' + opts;
  document.cookie = cookieName('user_subname') + '=' + encodeURIComponent(sub_name) + ';' + opts;
};

export const getCookies = (cname: string) => {
  const name = cookieName(cname) + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      const value = c.substring(name.length, c.length);
      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }
  }
  return '';
};

export const removeCookies = () => {
  const keys = ['bearer_token', 'user_name', 'user_subname', 'user_uuid', 'user_email'];
  for (const k of keys) {
    document.cookie = cookieName(k) + '=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    for (const lp of legacyPrefixes) {
      document.cookie = `${lp}${k}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
  }
};
